import { defineComponent as _defineComponent } from 'vue'
import SidebarItemGroup from './SidebarItemGroup.vue';

export interface SidebarItem {
    label: string;
    icon?: string;
    href?: string;
    children?: SidebarItem[];
}

export interface SidebarNavProps {
    items: SidebarItem[];
    isCollapsed?: boolean;
    active?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SidebarNav',
  props: {
    items: null,
    isCollapsed: { type: Boolean },
    active: null
  },
  setup(__props: any) {

const props = __props as {
    items: SidebarItem[];
    isCollapsed?: boolean;
    active?: string;
};




return { __sfc: true,props, SidebarItemGroup }
}

})